module.exports = __webpack_public_path__ + "media/flags/il-a30dcc6e.svg";